import {
    COUNTRIES_LIST,
    REGIONS_COLLECTION,
    SETTLEMENT_COLLECTION,
} from '@app/pages/clinic/models/country-related.data';
import { ChangeDetectionStrategy, Component, OnInit, effect, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectChangeEvent, SelectModule } from 'primeng/select';
import { Subject, distinctUntilChanged, takeUntil } from 'rxjs';

import { AnimalAddressForm } from '@app/models/chip.model';
import { FloatLabel } from "primeng/floatlabel";
import { InputTextModule } from 'primeng/inputtext';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-animal-address-form',
    imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    FloatLabel,
    InputTextModule,
    SelectModule,
],
    templateUrl: './animal-address-form.component.html',
    styleUrl: './animal-address-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnimalAddressFormComponent implements OnInit {
    readonly formGroup = input.required<FormGroup<AnimalAddressForm>>();
    readonly isAddressSameAsOwner = input<boolean>(false);

    private destroy$ = new Subject<void>();
    countries = COUNTRIES_LIST;
    regions = REGIONS_COLLECTION;
    settlements = SETTLEMENT_COLLECTION;

    constructor() {
        effect(() => {
            if (this.isAddressSameAsOwner()) {
                const { countryId, regionId } = this.formGroup().getRawValue();
                if (countryId && regionId) {
                    this.updateRegionList(countryId);
                    this.updateSettlementList(regionId);
                }
            }
        });
    }

    ngOnInit(): void {
        this.changeCountry({value: 1});

        this.formGroup().valueChanges
            .pipe(
                distinctUntilChanged(),
                takeUntil(this.destroy$),
            )
            .subscribe(formValue => {
                const { countryId, regionId, settlementId } = formValue;
                if (countryId && regionId ) {
                    this.updateRegionList(countryId);
                }
                if (settlementId && regionId) {
                    this.updateSettlementList(regionId);
                }
            })
    }

    changeCountry({value: countryId}: SelectChangeEvent): void {
        this.updateRegionList(countryId);
        this.changeRegion({value: this.regions[0]?.id});
        this.formGroup().get('regionId')?.setValue(null);
    }

    changeRegion({value: regionId}: SelectChangeEvent): void {
        this.updateSettlementList(regionId);
        this.formGroup().get('settlementId')?.setValue(null);
    }

    updateRegionList(countryId: number): void {
        this.regions = REGIONS_COLLECTION.filter((region) => region.countryId === countryId);
    }

    updateSettlementList(regionId: number): void {
        this.settlements = SETTLEMENT_COLLECTION.filter(
            (settlement) => settlement.regionId === regionId,
        );
    }
}
